import generateAsyncRouteComponent from '../generateAsyncRouteComponent';

export default {
  path: 'gift-vouchers/',
  component: generateAsyncRouteComponent({
    loader: () => import('./components/Voucher'),
  }),
};
